import DataApi from './DataApi';

class StorageApi extends DataApi {
  constructor() {
    super('storage');
  }

  fetchUsage() {
    return this.get('/usage');
  }

  fetchObjects({ page = 1, pageSize = 20, search = '' } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    if (search && String(search).trim()) {
      params.set('q', String(search).trim());
    }
    return this.get(`/objects?${params.toString()}`);
  }

  reconcile() {
    return this.post('/reconcile', {});
  }
}

export default StorageApi;
